import { VStack, Button, Text, Divider, Flex, Link, Spacer, useToast, Stack } from '@chakra-ui/react'
import { useEffect, useState, useRef } from 'react'
import { Link as ReactLink } from 'react-router-dom'
import { BsFileEarmarkText, BsPencilSquare } from "react-icons/bs";
import { getFormRequestFileUrl } from '../../classes/FormRequest';
import { useFormRquestContext } from '../../context/formRequestContext';
import { useUserContext } from '../../context/userContext';
import { toastErrDesc,toastVal } from '../../utils/toastUtils';
import { LabelInfo } from '../../components/shared'
import { dateTH } from '../../utils/dateUtils'

const RequesterInfo = ({ data }) => {
    // ผู้ขอ
    // ตำแหน่ง
    // สังกัด
    return (
        <VStack w="full">
            <LabelInfo title="ผู้ขอ">{`${data.requester_first_name} ${data.requester_last_name}`}</LabelInfo>
            <LabelInfo title="ตำแหน่ง">{data.requester_position_name}</LabelInfo>
            <LabelInfo title="สังกัด">{data.office_name}</LabelInfo>
        </VStack>
    )
}

const ResidenceInfo = ({ data }) => {
    // ขอเข้าพักที่ 
    // วันที่บันทึกข้อมูลแบบฟอร์ม
    // สถานะของแบบคำร้อง
    return (
        <VStack w="full">
            <LabelInfo title="ขอเข้าพักที่">{data.residence_name}</LabelInfo>
            <LabelInfo title="วันที่บันทึกข้อมูล">{dateTH(data.form_date)}</LabelInfo>
            <LabelInfo title="สถานะของแบบคำขอ">{data.form_status_name}</LabelInfo>
            <LabelInfo title="วันที่ยืนยันการยื่นแบบคำขอ">{data.submit_date || '-'}</LabelInfo>
        </VStack>
    )
}

const FormDownloadButton = ({ fid }) => {
    const toast = useToast()
    const { userData } = useUserContext()
    const [link, setLink] = useState(null)
    const download = useRef()
    download.current = async () => {
        try {
            const res = await getFormRequestFileUrl(fid, userData.token)
            if (res) {
                setLink(res)
            }

        } catch (error) {
            // alert(toastErrDesc(error))
            toast(toastVal({
                title: "การบันทึกข้อมูล ไม่สำเร็จ",
                description: toastErrDesc(error),
                status: "error",
            }))
        }
    }

    useEffect(() => {
        download.current()
    }, [])

    return (
        <Link href={link} isExternal _hover={{ textDecoration: 'none' }}>
            <Button colorScheme="blue" w={{base:"full",md:"fit-content"}} leftIcon={<BsFileEarmarkText />} isLoading={!link} >ดูไฟล์</Button>
        </Link>
    )
}

const FormDownLoad = ({ fid }) => {
    return (
        <Flex direction="column" w="full" pt={4}>
            <Stack w="full" direction={{ base: "column", md: "row" }} align={{base:"",md:"center"}}>
                <Text fontWeight="bold">ดาวน์โหลดแบบฟอร์มคำร้องของท่าน</Text>
                {/* <Link href={link} isExternal _hover={{ textDecoration: 'none' }}>
                    <Button colorScheme="green" leftIcon={<BsFileEarmarkArrowDown />} isLoading={!link}>ดาวน์โหลด</Button>
                </Link> */}
                <FormDownloadButton fid={fid} />
                <Spacer />
                <Link as={ReactLink} to={`/form/${fid}/edit`}>
                    <Button colorScheme="yellow" leftIcon={<BsPencilSquare />} w={{base:"full",md:"fit-content"}}>แก้ไขข้อมูลในแบบฟอร์ม</Button>
                </Link>
            </Stack>
            <Divider mt={8} />
        </Flex>
    )
}

const FormInfo = () => {
    const { formReqData } = useFormRquestContext()

    return (
        <VStack w="full" >
            <Stack w="full" direction={{ base: "column", md: "row" }}>
                <RequesterInfo data={formReqData} />
                <ResidenceInfo data={formReqData} />
            </Stack>
            <FormDownLoad fid={formReqData?.id} />
        </VStack>
    )
}

export default FormInfo
export { FormDownloadButton }
